<template>
  <div>
    <CCard class="">
      <CCol sm="12" class="justify-content-center custom-top">
        <CContainer>
          <br /><br />
          
          <CRow class="justify-content-center">
            <vue-ellipse-progress
              :data="circles"
              :progress="qSummary.score.toFixed(2)"
              :angle="-90"
              :color="GetColor(qSummary.score.toFixed(2))"
              :colorFill="colorFillGradient"
              emptyColor=" #40E0D0"
              :emptyColorFill="emptyColorFillGradient"
              :size="150"
              :thickness="6"
              emptyThickness="10%"
              lineMode="in 10"
              :legend="true"
              :legendValue="qSummary.score.toFixed(2)"
              legendClass="legend-custom-style"
              dash="50 0.9"
              animation="loop 1000 100"
              :noData="false"
              :loading="false"
              fontColor="blue"
              :half="false"
              :gap="10"
              fontSize="1.5rem"
            >
              <span slot="legend-value">%</span>
            </vue-ellipse-progress>
          </CRow>
            <br />
          <CRow class="justify-content-center">
            <p style="font-size: 25px; color: #000000"><strong>Your Score</strong></p>
          </CRow>
          <br />

          <!-- Student Name -->
          <CCard
            color="light"
            body-wrapper
            text-color="black"
            style="background: #ebedef; border: 1px solid #009688;"
            class="box-shadow"
          >
            <CRow class="col-12">
              <CCol class="item-left col-12">
                <h5 class="custom-font">Title: <strong>{{ qSummary.quizTitle }}</strong></h5>
              </CCol>
            </CRow>
          </CCard>

          <!-- Quiz Title  -->
          <CRow class="align-item-center" col="12">
            <CCol col="6">
              <CCard
                color="light"
                body-wrapper
                text-color="black"
                class="bg-gradient-orange box-shadow"
                style="height: 125px"
              >
                <CRow col-12>
                  <CCol class="col-12">
                    <h5 class="text-left text-white bold">
                     <CIcon name="cil-list" class="text-white mr-3" width="25px" />  Subject
                    </h5>
                  </CCol>
                
                  <CCol sm="12" lg="12">
                    <h6
                      class="text-left text-white custom-font"
                    >
                      {{ qSummary.subjectName }}
                    </h6>
                  </CCol>
                </CRow>
              </CCard>
            </CCol>

            <!-- Grade -->
            <CCol col="6">
              <CCard
                color="light"
                body-wrapper
                text-color="black"
                class="bg-gradient-green box-shadow"
                style="height: 125px"
              >
                <CRow>
                  <CCol class="col-12">
                    <h5 class="text-left text-white">
                      <CIcon name="cil-education" class="text-white mr-3" width="25px" />  Grade
                    </h5>
                  </CCol>
                  <CCol sm="12" lg="12">
                    <h6
                      class="text-left text-white custom-font"
                    >
                      {{ qSummary.gradeName }}
                    </h6>
                  </CCol>
                </CRow>
              </CCard>
            </CCol>
          </CRow>

          <!-- Teacher name -->
          <CRow col="12">
            <CCol class="col-6">
              <CCard
                color="light"
                body-wrapper
                text-color="black"
                class="bg-gradient-turqouise box-shadow"
                style="height: 125px"
              >
                <CRow col-12>
                  <CCol class="col-12">
                    <h5 class="text-left text-white bold">
                        <CIcon name="cil-user" class="text-white mr-3" width="25px" /> Teacher
                    </h5>
                  </CCol>

                  <CCol sm="12" lg="12">
                    <h6
                      class="
                        text-left
                        custom-font
                        text-white
                      "
                    >
                      {{ qSummary.publishBy }}
                    </h6>
                  </CCol>
                </CRow>
              </CCard>
            </CCol>

            <!-- Duration -->
            <CCol class="col-6">
              <CCard
                color="light"
                body-wrapper
                text-color="black"
                class="bg-gradient-purple box-shadow"
                style="height: 125px"
              >
                <CRow>
                  <CCol class="col-12">
                    <h5 class="text-left text-white bold">
                        <CIcon name="cil-av-timer" class="text-white mr-2" width="25px" /> Duration
                    </h5>
                  </CCol>
                  <CCol sm="12" lg="12">
                    <h6
                      class="
                        text-left
                        text-white
                        bold
                        custom-font
                      "
                    >
                      {{ qSummary.TimerString }}
                    </h6>
                  </CCol>
                </CRow>
              </CCard>
            </CCol>
          </CRow>

          <div>
            <!-- <CButton
            color="success"
            class="custom-btn"
            size="lg"
            block
            :disabled="isDisabled"
            @click="GotoPageListQuestion()"
            >Check Answer</CButton -->
          

            <CButton
              color="success"
              class="custom-btn mt-1 mb-4"
              size="lg"
              block
              :disabled="isDisabled"
              @click="GoToDashBoard"
              >Close</CButton
            >
          </div>
        </CContainer>
      </CCol>
    </CCard>

 
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import VueEllipseProgress from "vue-ellipse-progress";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
Vue.use(VueEllipseProgress);

export default {
  name: "Login",
  components: {
    PulseLoader,
  },

  data() {
    return {
      backgroundBanner,
      qSummary: {},
      SubmittedForm: false,
      Error: false,
      progress: "",
      StudentProfile: {}
    };
  },
  computed: {},
  async mounted() {
    this.GetStudentProfile();
    this.GetStudentFinalScore();
  },
  methods: {
    EShop() {
      this.$router.push(
        "/QuizStudentSubscription?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    //Get student name
    async GetStudentProfile() {
      this.$API
        .get(
          this.$StudentProfile +
            "?studentId=" +
            this.$route.query.studentId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.StudentProfile = response.data;
            console.log("StudentProfile", this.StudentProfile);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //Get quiz summary
    async GetStudentFinalScore() {
      this.$API
        .get(
          this.$GetStudentFinalScore +
            "?studentId=" +
            this.$route.query.studentId +
            "&startId=" +
            this.$route.query.startId +
            "&quizId=" +
            this.$route.query.quizId,
            {
            withCredentials: true
            }
        )
        .then(response => {
            if (response.status == 200 && response.data != null) {
              this.qSummary = response.data;
              this.GetColor(this.qSummary.score);
            }
          })           
          .catch(function (error) {
            console.log(error.response);
          });
    },
    GotoPageListQuestion() {
      this.$router.push(
        "/QuizStudentListQuestion?quizScoreId=" +
          this.$route.query.quizScoreId + 
          "&studentId=" +
          this.$route.query.studentId +
          "&userId=" +
          this.$route.query.userId
      );
    },
    GoToDashBoard() {
      this.$router.push(
        "/QuizStudentDashboard?studentId=" +
          this.$route.query.studentId +
          "&userId=" +
          this.$route.query.userId
      );
    },
    GetColor: function () {
      console.log("e" + this.qSummary.score);
      if (this.qSummary.score <= 39) {
        return "red";
      } else if (this.qSummary.score <= 79) {
        return "yellow";
      } else if (this.qSummary.score >= 80) {
        return "green";
      }
      return "";
    },
  },
};
</script>

<style>
.coin-right {
  border-radius: 30px;
  border-color: #ffff00;
  border-width: 3px;
  color: #000000;          
  width: 20%;
  position: absolute;
  top: 50%;
  left: 80%;
  transform: translate(-30%, -10%);
  background: rgb(255,255,255);
  background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,220,160,0.8015581232492998) 80%);
}
.coin_card{
  background: rgb(179,155,255);
background: linear-gradient(180deg, rgba(179,155,255,0.5914740896358543) 10%, rgba(255,220,160,0.8015581232492998) 60%);
}

.coin_card2{
 background: rgb(255,220,160);
background: linear-gradient(180deg, rgba(255,220,160,0.8015581232492998) 40%, rgba(179,155,255,0.6194852941176471) 80%);
}
</style>